// config
import { fbConf } from '../config/firebase-config';

import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AngularFireDatabaseWrapper } from '../providers/angularfire-wrapper';
import { SmartApp } from './app.component';
import { AppSettings } from '../config/app-settings';
import { UserData } from '../providers/user-data';
import { FeedData } from '../providers/feed-data';
import { DonationData } from '../providers/donation-data';
import { CartData } from '../providers/cart-data';
import { AngularFireModule } from 'angularfire2';
import { FirebaseData } from '../providers/firebase-data';
import { FirebaseStorage } from '../providers/firebase-storage';
import { ElasticSearchService } from '../providers/elastic-search';
import { CoreModule, PageRef} from '../core/core.module';
import { Helpers } from '../providers/helpers';
import { Navigation } from '../core/navigation';
import { IonImgCache, IonImgCacheService } from '../modules/ionic2-img-cache/ion-img-cache';
// angulartics piwik
import { Angulartics2Module, Angulartics2Piwik } from "angulartics2";
// end angulartics piwik
// Pages
import { CartPage } from '../pages/cart/cart';
import { ContactPage } from '../pages/contact/contact';
import { EventsPage } from '../pages/events/events';
import { FeedPage } from '../pages/feed/feed';
import { UserFeedPage } from '../pages/feed/user-feed';
import { GivingPage } from '../pages/giving/giving';
import { NewsPage } from '../pages/news/news';
import { NewsDetailsPage } from '../pages/news/news-details';
import { OrdersPage } from '../pages/orders/orders';
import { StoreDetailsPage } from '../pages/orders/components/store-details';
import { ProductDetailsPage } from '../pages/orders/components/product-details';
import { StoreListingPage } from '../pages/orders/store-listing';
import { OrderHistoryPage } from '../pages/orders/order-history';
import { TabsPage } from '../pages/tabs/tabs';

// Components

// Modules
import { HomeModule } from '../modules/home/home.module';
import { AccountModule } from '../modules/account/account.module';
import { WeeklyAdModule } from '../modules/weekly-ad/weekly-ad.module';
import { RecipesModule } from '../modules/recipes/recipes.module';
import { CouponsModule } from '../modules/coupons/coupons.module';
import { StoreLocatorModule } from '../modules/store-locator/store-locator.module';
import { MenuMoreModule } from '../modules/menu-more/menu-more.module';
import { AboutUsModule } from '../modules/about-us/about-us.module';
import { SpecialModule } from '../modules/special/special.module';
import { ProductModule } from '../modules/product/product.module';
import { DynamicPageModule } from '../modules/dynamic-page/dynamic-page.module';
import { DynamicHTMLModule } from '../modules/dynamic-html/dynamic-html.module';
import { ServicesModule } from '../modules/services/services.module';

import { ShareButtonsModule } from "ng2-sharebuttons";

export function provideStorage() {
 return new Storage(['sqlite', 'websql', 'localstorage'], { name: '__smartappStorage' } /* optional config */);
}
@NgModule({
  declarations: [
    SmartApp,
    CartPage,
    ContactPage,
    EventsPage,
    FeedPage,
    UserFeedPage,
    GivingPage,
    NewsPage,
    NewsDetailsPage,
    OrdersPage,
    StoreDetailsPage,
    ProductDetailsPage,
    StoreListingPage,
    OrderHistoryPage,
    TabsPage
  ],
  imports: [
    IonicModule.forRoot(SmartApp, {
      tabsPlacement: 'bottom',
      backButtonText: 'Back',
      prodMode: true,
      tabsHighlight: true,
      statusbarPadding: false,
      mode: 'ios'
    },{
        links: []
    }),
    AngularFireModule.initializeApp(fbConf),
    IonImgCache,
    Angulartics2Module.forRoot([ Angulartics2Piwik ]),
    CoreModule,
    FormsModule, 
    TextMaskModule,
    DynamicHTMLModule,
    HomeModule,
    AccountModule,
    WeeklyAdModule,
    RecipesModule,
    CouponsModule,
    StoreLocatorModule,
    MenuMoreModule ,
    AboutUsModule,
    SpecialModule,
    ProductModule,
    DynamicPageModule,
    ShareButtonsModule,
    ServicesModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    SmartApp,
    CartPage,
    ContactPage,
    EventsPage,
    FeedPage,
    UserFeedPage,
    GivingPage,
    NewsPage,
    NewsDetailsPage,
    OrdersPage,
    StoreDetailsPage,
    ProductDetailsPage,
    StoreListingPage,
    OrderHistoryPage,
    TabsPage
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler}, 
    AppSettings, 
    {provide: Storage, useFactory: provideStorage },
    // Storage,
    AngularFireDatabaseWrapper,
    IonImgCacheService,
    DonationData, 
    FeedData, 
    CartData, 
    FirebaseData,
    ElasticSearchService, 
    UserData, 
    FirebaseStorage, 
    PageRef, 
    Helpers, 
    Navigation]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts